import apiClient from './apiClient';

export interface ImportRow {
  row_number: number;
  status: string;
  normalized_data: { email: string; name: string; title: string; company: string };
  error_codes: string[];
}

export interface ImportBatch {
  id: string;
  event_id: string;
  state: 'validated' | 'confirmed' | 'rejected';
  summary: Record<string, number>;
  created_at: string;
  rows: ImportRow[];
}

export const registrationImportService = {
  latest(eventId: string): Promise<ImportBatch | null> {
    return apiClient.get<ImportBatch | null>(`/admin/events/${eventId}/attendee-imports/latest?state=validated`);
  },
  preview(eventId: string, file: File): Promise<ImportBatch> {
    const form = new FormData();
    form.append('file', file);
    return apiClient.upload<ImportBatch>(`/admin/events/${eventId}/attendee-imports/preview`, form);
  },
  confirm(eventId: string, batchId: string): Promise<ImportBatch> {
    return apiClient.post<ImportBatch>(`/admin/events/${eventId}/attendee-imports/${batchId}/confirm`, {}, { 'Idempotency-Key': crypto.randomUUID() });
  },
  activate(eventId: string, batchId: string): Promise<{ id: string; state: string; summary: Record<string, number> }> {
    return apiClient.post(`/admin/events/${eventId}/activation-jobs`, { import_batch_id: batchId, mode: 'unsent' }, { 'Idempotency-Key': crypto.randomUUID() });
  },
};
